<div class="activity-panel">
  <div class="home" id="onActivityLoad">
    <app-activity-feed></app-activity-feed>
  </div>
</div>
